export const reduceCompareFeaturesResponse = ({
  data,
  state
}) => {
  return Object.assign({}, state, {
    features: data
  });
};
export const reduceAddCompareResponse = ({
  state,
  payload
}) => {
  return Object.assign({}, state, {
    apiNames: [...state.apiNames, payload]
  });
};
export const reduceAddAllCompareResponse = ({
  state,
  payload
}) => {
  return Object.assign({}, state, {
    apiNames: [...state.apiNames, ...payload]
  });
};
export const reduceRemoveCompareResponse = ({
  state,
  payload
}) => {
  const filteredApiNames = state.apiNames.filter(apiName => {
    return apiName !== payload;
  });
  return Object.assign({}, state, {
    apiNames: filteredApiNames
  });
};
export const reduceUpdateCompareResponse = ({
  state,
  payload: {
    prevProduct,
    nextProduct
  }
}) => {
  const index = state.apiNames.indexOf(prevProduct);
  if (index === -1) return state;
  return Object.assign({}, state, {
    apiNames: [...state.apiNames.slice(0, index), nextProduct, ...state.apiNames.slice(index + 1)]
  });
};